/* unplugin-vue-components disabled */import script from "./DataCellTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataCellTabs.vue?vue&type=script&setup=true&lang=ts"

import "./DataCellTabs.vue?vue&type=style&index=0&id=724dda4a&lang=less"

const __exports__ = script;

export default __exports__